module.exports = __webpack_public_path__ + "static/media/time.52ba8fe2.svg";